import { Dispatch, SetStateAction } from 'react'
import { StartEndMonth } from '../../interfaces/project/StartEndMonth'
import { FluentModal } from '../Modals/FluentModal/FluentModal'
import AccountSpecificationGrid from './AccountSpecificationGrid/AccountSpecificationGrid'
import { useProjectInfo } from '../../fetchData/queries/useProjectInfo'
const modalStyleOverrides = {
  surface: {
    maxWidth: 'revert',
    minWidth: 'max(900px, 95vw)',
    width: 'fit-content',
  },
}

interface AccountSpecificationProps {
  modalAccountId: string
  modalOutcomeDate: string
  startEndMonth: StartEndMonth
  isAccountSpecificationModalOpen: boolean
  setIsAccountSpecificationModalOpen: Dispatch<SetStateAction<boolean>>
}

const AccountSpecification = ({
  modalAccountId,
  modalOutcomeDate,
  startEndMonth,
  isAccountSpecificationModalOpen,
  setIsAccountSpecificationModalOpen,
}: AccountSpecificationProps) => {
  const { data } = useProjectInfo()
  const projectName = data?.name
  const projectIdNr = data?.identificationNumber?.toString()
  const isOmbyggnad = data?.class?.group === 'Ombyggnad'

  const modalContent = (
    <AccountSpecificationGrid
      modalAccountId={modalAccountId}
      modalOutcomeDate={modalOutcomeDate}
      startEndMonth={startEndMonth}
      isOmbyggnad={isOmbyggnad}
    />
  )

  return (
    <FluentModal
      isModalOpen={isAccountSpecificationModalOpen}
      setIsModalOpen={setIsAccountSpecificationModalOpen}
      isModeLess={false}
      modalHeader={`${projectName} - ${projectIdNr}`}
      modalContent={modalContent}
      styleOverrides={modalStyleOverrides}
    />
  )
}

export default AccountSpecification
